import { create } from "zustand";
import userApi from "../services/api/userApi";
sessionStorage.removeItem("chat_session");
const savedSession = "";
const useChat = create((set, get) => ({

  session: savedSession,
  messages: [],
  isTyping: false,
  currentBotMessage: "",
  botTyping: false,
  habilitaImagens: false,
  habilitaEmail: false,
  habilitaZendesk: false,
  habilitaContexto: true,
  habilitaVoz: false,
  engine: "azure",
  shouldLog: true,
  temperature: "0.2",
  telegramToken: "",
  memory_saudacao: "",
  memory_despedida: "",
  inactivityTimeout: 600,
  richPrompt: true,
  richPrompt_qtd: 20,
  opcaoNum: true,
  qtdDoc: 5,
  nearDoc: 0.6,
  finalStepQuestions: [],
  rulesConditions: [],
  perguntas_guiadas: false,
  tem_perguntas_guiadas: false,
  fimConversa: false,

  docs_vazios_fim_conversa: 0,

  setDocsVaziosFimConversa: (docs_vazios_fim_conversa) => {
    set({ docs_vazios_fim_conversa });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setFimConversa: (fimConversa) => {
    set({ fimConversa });
  },
  setRulesConditions: (rulesConditions) => {
    set({ rulesConditions });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setTemPerguntasGuiadas: (tem_perguntas_guiadas) => {
    set({ tem_perguntas_guiadas });
  },
  setPerguntasGuiadas: (perguntas_guiadas) => {
    set({ perguntas_guiadas });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setFinalStepQuestions: (finalStepQuestions) => {
    set({ finalStepQuestions });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setMemoryDespedida: (memory_despedida) => {
    set({ memory_despedida });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  setInactivityTimeout: (seconds) => {
    set({ inactivityTimeout: seconds });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  loadingSettings: true,
  setLoadingSettings: (loading) => set({ loadingSettings: loading }),


  clearSession: (session, clear = false) => {
    if (session) {
      sessionStorage.setItem("chat_session", session);
    } else {
      sessionStorage.removeItem("chat_session");
    }
    set({ session: null });
  },
  setSession: (session, clear = false) => {
    if (session && !clear) {
      sessionStorage.setItem("chat_session", session);
    } else {
      sessionStorage.removeItem("chat_session");
    }
    set({ session });
  },
  setMessages: (messages) => set({ messages }),
  setIsTyping: (isTyping) => set({ isTyping }),
  setCurrentBotMessage: (currentBotMessage) =>
    set((state) => ({
      currentBotMessage:
        typeof currentBotMessage === "function"
          ? currentBotMessage(state.currentBotMessage)
          : currentBotMessage,
    })),
  setBotTyping: (botTyping) => set({ botTyping }),

  setHabilitaImagens: (habilitaImagens) => {
    set({ habilitaImagens });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setHabilitaEmail: (habilitaEmail) => {
    set({ habilitaEmail });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setHabilitaZendesk: (habilitaZendesk) => {
    set({ habilitaZendesk });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setHabilitaContexto: (habilitaContexto) => {
    set({ habilitaContexto });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setEngine: (engine) => {
    set({ engine });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setTemperature: (temperature) => {
    set({ temperature: temperature.toFixed(1) });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setMemorySaudacao: (memory_saudacao) => {
    set({ memory_saudacao });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },
  setShouldLog: (shouldLog) => {
    set({ shouldLog });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  setRichPrompt: (richPrompt) => {
    set({ richPrompt });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  setRichPromptQtd: (richPrompt_qtd) => {
    set({ richPrompt_qtd });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  setOpcaoNum: (opcaoNum) => {
    set({ opcaoNum });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  setQtdDoc: (qtdDoc) => {
    set({ qtdDoc });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  setNearDoc: (nearDoc) => {
    set({ nearDoc });
    if (!get().loadingSettings) get().saveSettingsToAPI();
  },

  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),

  clearMessages: () => set({ messages: [] }),

  loadSettingsFromAPI: async () => {
    get().setLoadingSettings(true);
    try {
      const response = await userApi.workspace();
      if (response.data.frontend) {
        set(response.data.frontend);
      }
    } catch (error) {
      console.error("Erro ao carregar configurações do chat:", error);
    } finally {
      get().setLoadingSettings(false);
    }
  },


  saveSettingsToAPI: async () => {
    try {
      const {
        habilitaImagens,
        habilitaEmail,
        habilitaZendesk,
        habilitaContexto,
        habilitaVoz,
        engine,
        shouldLog,
        temperature,
        telegramToken,
        memory_saudacao,
        inactivityTimeout,
        memory_despedida,
        richPrompt,
        richPrompt_qtd,
        opcaoNum,
        qtdDoc,
        nearDoc,
        finalStepQuestions,
        rulesConditions,
        perguntas_guiadas,
        docs_vazios_fim_conversa

      } = get();
      await userApi.workspaceUpdate({
        habilitaImagens,
        habilitaEmail,
        habilitaZendesk,
        habilitaContexto,
        habilitaVoz,
        engine,
        shouldLog,
        temperature,
        telegramToken,
        memory_saudacao,
        inactivityTimeout,
        memory_despedida,
        richPrompt,
        richPrompt_qtd,
        opcaoNum,
        qtdDoc,
        nearDoc,
        finalStepQuestions,
        rulesConditions,
        perguntas_guiadas,
        docs_vazios_fim_conversa

      });
    } catch (error) {
      console.error("Erro ao salvar configurações do chat:", error);
    }
  },
}));

export default useChat;
